import { createFileRoute } from "@tanstack/react-router"
import * as React from "react"
import { PageHeader, Toolbar } from "@/components/layout"
import { SegmentedFilter } from "@/features/api-requests-admin/SegmentedFilter"
import { AdoptionGapsPanel } from "@/features/api-usage/AdoptionGapsPanel"
import {
	resolveRange,
	USAGE_WINDOWS,
	type UsageSearch,
} from "@/features/api-usage/filters"

export const Route = createFileRoute("/api-usage/adoption-gaps")({
	component: AdoptionGapsPage,
})

function AdoptionGapsPage() {
	const [window, setWindow] = React.useState<UsageSearch["window"]>("30d")
	const { from, to } = React.useMemo(
		() => resolveRange({ window, accessMode: "all" }),
		[window],
	)

	return (
		<div className="flex flex-col gap-6 p-6">
			<PageHeader
				title="Adoption gaps"
				description="Credentials, grants and keys that exist but have never been exercised"
			/>

			<Toolbar>
				<SegmentedFilter
					label="Window"
					options={USAGE_WINDOWS}
					value={window}
					onChange={setWindow}
				/>
			</Toolbar>

			<AdoptionGapsPanel from={from.toISOString()} to={to.toISOString()} />
		</div>
	)
}
